import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { feedbackAndQuestionNoticeListSchema } from '../../../common/validations/feedbackAndQuestionNotice'

import { get } from 'api/apiClient'

const params = (uuid: string) => ({
  queryKey: [`${API_ENDPOINTS.CONTRACTS}/${uuid}/feedbacks`],
  queryFn: () =>
    get(
      `${API_ENDPOINTS.CONTRACTS}/${uuid}/feedbacks`,
      feedbackAndQuestionNoticeListSchema
    ),
})

export const useAPIGetFeedbackNotices = (uuid: string) => useQuery(params(uuid))

export const useAPIGetFeedbackNoticesSuspense = (uuid: string) =>
  useSuspenseQuery(params(uuid))
